import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { solutionDetails } from '../data/mapData';
import aiStarImg from '../assets/AI-Star.png';

const BLOB_SAS = 'se=2031-01-01T00%3A00%3A00Z&sp=rl&spr=https&sv=2026-02-06&sr=c&sig=vTlmzUVlB8hgckse7jND%2BTNyhWVC/B/1Dwv39LqZT7o%3D';
function getVideoSrc(src) {
  if (!src) return src;
  return src.startsWith('https://corpheadlesscmssales.blob.core.windows.net')
    ? `${src}?${BLOB_SAS}`
    : src;
}

function isAiVideo(url) {
  if (!url) return false;
  try { const name = new URL(url).pathname.split('/').pop().toLowerCase(); return name.startsWith('resort') || name.startsWith('casino') || name.startsWith('he') || name.startsWith('eatec'); } catch(e) { return false; }
}

function PlayIcon() {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
      <circle cx="20" cy="20" r="20" fill="rgba(255,255,255,0.25)" />
      <polygon points="16,12 30,20 16,28" fill="#fff" />
    </svg>
  );
}

function StarBadge() {
  return (
    <div className="star-badge">
      <img src={aiStarImg} alt="AI" />
    </div>
  );
}

function CloseIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M6 18L18 6M6 6l12 12" />
    </svg>
  );
}

function Solution() {
  const { id } = useParams();
  const sol = solutionDetails[id];
  const [showPopup, setShowPopup] = useState(false);
  const [activeVideo, setActiveVideo] = useState(null);

  if (!sol) {
    return (
      <div className="page">
        <div className="page-header">Solution</div>
        <div className="text-blocks">
          <div className="std-text">Solution not found.</div>
        </div>
      </div>
    );
  }

  const isExpressMobile = id === 'express-mobile';

  const isService = id === 'service';

  return (
    <div className={`page splash ${sol.pageClass}`}>
      <div className="page-title">
        <img src={sol.icon} alt="" />
      </div>

      {isExpressMobile ? (
        <div className="text-blocks">
          <div className="std-text">A complete mobile check-in and check-out guest experience with support for:{"\n\n"}</div>
          <div className="std-text">
            <ul>
              <li><div className="dot" />Digital Keys</li>
              <li><div className="dot" />ID Verification</li>
              <li><div className="dot" />Key Encoding</li>
              <li><div className="dot" />Room Ready Messaging</li>
            </ul>
            {"\n"}
          </div>
          <div className="std-text">With Express, guests can avoid long front desk lines and enjoy a complete contactless process getting to their rooms and the property's amenities faster. The result is reduced lines at the front desk, greater staff productivity, and reduced operating costs.</div>
        </div>
      ) : (
        <div className="text-blocks">
          {sol.description.split('\n\n').map((t, i, arr) => (
            <div key={i} className="std-text">{t}{i < arr.length - 1 ? "\n\n" : ""}</div>
          ))}
        </div>
      )}

      {sol.video && sol.video2 ? (
        isService ? (
          <div className="video-buttons">
            <div className="play-video" onClick={() => { setActiveVideo(getVideoSrc(sol.video)); setShowPopup(true); }}>
              <PlayIcon />
              {sol.videoLabel || 'Play Video 1'}
              {isAiVideo(sol.video) && <StarBadge />}
            </div>
            <div className="play-video" onClick={() => { setActiveVideo(getVideoSrc(sol.video2)); setShowPopup(true); }}>
              <PlayIcon />
              {sol.video2Label || 'Play Video 2'}
              {isAiVideo(sol.video2) && <StarBadge />}
            </div>
          </div>
        ) : (
          <>
            <div className="play-video" onClick={() => { setActiveVideo(getVideoSrc(sol.video)); setShowPopup(true); }}>
              <PlayIcon />
              {sol.videoLabel || 'Play Video 1'}
              {isAiVideo(sol.video) && <StarBadge />}
            </div>
            <div className="play-video" style={{ left: '28%' }} onClick={() => { setActiveVideo(getVideoSrc(sol.video2)); setShowPopup(true); }}>
              <PlayIcon />
              {sol.video2Label || 'Play Video 2'}
              {isAiVideo(sol.video2) && <StarBadge />}
            </div>
          </>
        )
      ) : sol.video ? (
        <div className="play-video" onClick={() => { setActiveVideo(getVideoSrc(sol.video)); setShowPopup(true); }}>
          <PlayIcon />
          <span>Play Video</span>
          {isAiVideo(sol.video) && <StarBadge />}
        </div>
      ) : null}

      {sol.img1 && <img className="img-1" src={sol.img1} alt="" />}
      {sol.img2 && <img className="img-2" src={sol.img2} alt="" />}
      {sol.img3 && <img className="img-3" src={sol.img3} alt="" />}

      {showPopup && activeVideo && (
        <div className="popup" style={{ display: 'flex' }}>
          <div className="offclick" onClick={() => { setShowPopup(false); setActiveVideo(null); }} />
          <div className="holder">
            <div className="close" onClick={() => { setShowPopup(false); setActiveVideo(null); }}>
              <CloseIcon />
            </div>
            <video
              key={activeVideo}
              autoPlay
              controls
              src={activeVideo}
              style={{ width: '100%', height: '100%', display: 'block' }}
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default Solution;
